<template lang="pug">
.member-icon
  img(:src="$data[grade]")
  
</template>
<script>
import primary from '@/assets/icons/member/primary.png'
import golden from '@/assets/icons/member/gold.png'
import platinum from '@/assets/icons/member/platinum.png'
import diamond from '@/assets/icons/member/diamond.png'
export default {
  name: 'MemberIcon',
  props: {
    grade: {},
  },
  data() {
    return {
      primary: primary,
      golden: golden,
      platinum: platinum,
      diamond: diamond,
    }
  },
  computed: {},
  methods: {},
  mounted() {},
}
</script>

<style scoped lang="sass">
@import "src/styles/common.sass"
.member-icon
  width: pxToRem(36)
  height: pxToRem(36)
  border-radius: pxToRem(18)
  overflow: hidden
  line-height: 0
  margin-right: pxToRem(10)
  img
    height: 100%
    object-fit: contain
</style>
